module.exports = __webpack_public_path__ + "static/img/1@2x.9270075.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/v17_new_features/1@2x.png
// module id = lpmP
// module chunks = 0